import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import FilterComponent from "../../../ReusableFIlterComponent/FilterComponent";
import {
  setSelectedActive,
  setSelectedDocumented,
  setSelectedMissedRun,
} from "../../../../features/unifierCalculationTypesSlice";

const SELECTED_COLOR = "#9C27B0";
const UNSELECTED_COLOR = "#000000DE";

// the three flags come back as 1/0, so the options are spelled out here rather
// than derived from the list
export const MISSED_RUN_OPTIONS = [
  { missed_run: "On" },
  { missed_run: "Off" },
];
export const DOCUMENTED_OPTIONS = [
  { documented: "Yes" },
  { documented: "No" },
];
export const ACTIVE_OPTIONS = [{ active: "Active" }, { active: "Inactive" }];

export const CalculationTypeFilterItems = ({
  clearSelectedCalculationName,
}: any) => {
  const { selectedMissedRun, selectedDocumented, selectedActive } = useSelector(
    (state: any) => state.unifierCalculationTypes,
  );
  const dispatch = useDispatch();

  const filterConfig = [
    {
      key: "Missed Run",
      label: "Select a Missed Run state",
      selectedOption: selectedMissedRun,
      filterName: "missed_run",
      data: MISSED_RUN_OPTIONS,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedMissedRun(updatedSelection)),
      count: selectedMissedRun && selectedMissedRun.length,
      colorSelected:
        selectedMissedRun !== null && selectedMissedRun.length > 0
          ? SELECTED_COLOR
          : UNSELECTED_COLOR,
      multiSelect: true,
      showSearch: false,
    },
    {
      key: "Documented",
      label: "Select a Documented state",
      selectedOption: selectedDocumented,
      filterName: "documented",
      data: DOCUMENTED_OPTIONS,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedDocumented(updatedSelection)),
      count: selectedDocumented && selectedDocumented.length,
      colorSelected:
        selectedDocumented !== null && selectedDocumented.length > 0
          ? SELECTED_COLOR
          : UNSELECTED_COLOR,
      multiSelect: true,
      showSearch: false,
    },
    {
      key: "Active",
      label: "Select an Active state",
      selectedOption: selectedActive,
      filterName: "active",
      data: ACTIVE_OPTIONS,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedActive(updatedSelection)),
      count: selectedActive && selectedActive.length,
      colorSelected:
        selectedActive !== null && selectedActive.length > 0
          ? SELECTED_COLOR
          : UNSELECTED_COLOR,
      multiSelect: true,
      showSearch: false,
    },
  ];

  const clearFilters = () => {
    clearSelectedCalculationName();
    dispatch(setSelectedMissedRun([]));
    dispatch(setSelectedDocumented([]));
    dispatch(setSelectedActive([]));
  };

  return (
    <Box>
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
        filterNameURL="calculationTypeFilters"
      />
    </Box>
  );
};

export default CalculationTypeFilterItems;
